import React from 'react';
import '../styles/Skeleton.css';

/**
 * Skeleton loading UI for chat messages
 * Shows animated placeholder while messages are loading
 * Industry-standard pattern (like Facebook, LinkedIn)
 */
const ChatMessageSkeleton = ({ count = 3 }) => {
  return (
    <div className="skeleton-messages">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`skeleton-message ${i % 2 === 0 ? 'skeleton-user' : 'skeleton-assistant'}`}
        >
          <div className="skeleton-avatar"></div>
          <div className="skeleton-content">
            <div className="skeleton-line skeleton-line-long"></div>
            <div className="skeleton-line skeleton-line-medium"></div>
            <div className="skeleton-line skeleton-line-short"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChatMessageSkeleton;
